import request from '@/utils/request'

// 商品供货商表 2021-04-29 09:30:13

let SupplierApi = {

    /*列表*/
    getList(data, errorback) {
        return request._post('/shop/supplier.Supplier/index', data, errorback);
    },
    /*列表*/
    orderlist(data, errorback) {
        return request._post('/shop/supplier.Supplier/orderList', data, errorback);
    },

    /*添加*/
    add(data, errorback) {
        return request._post('/shop/supplier.Supplier/add', data, errorback);
    },

    /*删除*/
    del(data, errorback) {
        return request._post('/shop/supplier.Supplier/del', data, errorback);
    },

    /*编辑*/
    edit(data, errorback) {
        return request._post('/shop/supplier.Supplier/edit', data, errorback);
    },
}

export default SupplierApi;



// WEBPACK FOOTER //
// ./src/api/supplier.js